exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#deleteModal > .modal {\n  width: 32% !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/delete-item-confirmation-dialog/delete-item-confirmation-dialog.component.scss
// module id = ../../../../../src/app/components/delete-item-confirmation-dialog/delete-item-confirmation-dialog.component.scss
// module chunks = main